import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
import type { LinkAccent, LinkSize } from './Link.types';

const baseAccentClassName =
  'cursor-pointer border-none bg-transparent no-underline focus-visible:outline-none focus-visible:ring';

const enabledAccentClassName: { [Key in LinkAccent]: string } = {
  positive: `${baseAccentClassName} text-element-secondary link-underline`,
  negative: `${baseAccentClassName} text-element-negative link-underline`,
  contrast: `${baseAccentClassName} text-contrast hover:text-contrast active:text-contrast focus-visible:text-contrast link-underline-static`,
};

const disabledAccentClassName =
  'pointer-events-none border-none text-status-disabled-dark no-underline';

const sizeClassName: { [Key in LinkSize]: string } = {
  small: 'text-xs rounded-sm',
  default: 'text-sm rounded',
  large: 'text-base rounded-lg',
};

export const getLinkClassNames = (
  className?: string,
  accent: LinkAccent = 'positive',
  size: LinkSize = 'default',
  disabled?: boolean,
): string =>
  twMerge(
    classNames(
      'relative inline-flex shrink-0 items-center justify-center gap-x-1 whitespace-nowrap p-0 font-semibold',
      disabled ? disabledAccentClassName : enabledAccentClassName[accent],
      sizeClassName[size],
    ),
    className,
  );

export const getLinkInnerClassNames = (loading?: boolean) =>
  classNames(
    'flex flex-1 shrink-0 items-center justify-center gap-x-1 whitespace-nowrap',
    loading && 'invisible',
  );

export const linkSpinnerWrapperClassNames =
  'absolute inset-0 flex items-center justify-center';
